import type { ReactNode } from 'react';

/**
 * A label/value description list, Stripe-style: muted label in a fixed
 * left column, value on the right, rows split by hairline dividers.
 * Shared by the read-only settings / stores / carriers cards. Labels
 * are used as React keys, so they must be unique within one list.
 */
export interface DetailItem {
  readonly label: string;
  readonly value: ReactNode;
}

interface DetailListProps {
  readonly items: readonly DetailItem[];
}

export function DetailList({ items }: DetailListProps) {
  return (
    <dl className="divide-border divide-y">
      {items.map((item) => (
        <div
          key={item.label}
          className="grid grid-cols-[160px_1fr] items-start gap-4 py-3 first:pt-0 last:pb-0"
        >
          <dt className="text-muted-foreground text-sm">{item.label}</dt>
          <dd className="text-foreground text-sm">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
